// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 2C15.7278 2 18.8198 4.71919 19.4016 8.28287C22.0637 9.09632 24 11.5712 24 14.5C24 18.0899 21.0898 21 17.5 21H6.5C2.91015 21 0 18.0899 0 14.5C0 11.5712 1.93625 9.09632 4.59837 8.28287C5.1802 4.71919 8.27221 2 12 2ZM15.0002 12.9141L16.4144 11.4999L12.0002 7.08569L7.58594 11.4999L9.00015 12.9141L11.0002 10.9141V16.9999H13.0002V10.9141L15.0002 12.9141Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-backup-filled')
export default class BackupFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'backup-filled',
    }
  }
}
